import type React from 'react';
import SvgIcon from './SvgIcon';

const FileUpload: React.FC = () => (
  <SvgIcon
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g id="FileUpload">
      <path d="M2 16H16V13H18V17C17.9999 17.5522 17.5522 18 17 18H1C0.447751 18 5.77208e-05 17.5522 0 17V13H2V16Z" fill="currentColor" />
      <path d="M9 0C9.26521 2.52928e-07 9.5195 0.105435 9.70703 0.292969L14.207 4.79297L12.793 6.20703L10 3.41406V13.5H8V3.41406L5.20703 6.20703L3.79297 4.79297L8.29297 0.292969L8.36621 0.226562C8.54417 0.0807264 8.76791 1.98886e-06 9 0Z" fill="currentColor" />
    </g>
  </SvgIcon>
);

export default FileUpload;
